import { useEditUser } from "@/api/mutations/users";
import type { UserItem } from "@/api/queries/users/types";
import { Switch } from "@/components/ui/switch";
import { TableCell } from "@/components/ui/table";
import { toast } from "sonner";

interface UserStatusProps {
  user: UserItem;
}

export const UserStatus = ({ user }: UserStatusProps) => {
  const { mutateAsync, isPending } = useEditUser(user.id);

  const handleToggle = async (user: UserItem) => {
    try {
      await mutateAsync({ active: !user.active });
      toast.success(`User ${!user.active ? "activated" : "deactivated"}`);
    } catch {
      toast.error("Failed to update user status");
    }
  };

  return (
    <TableCell>
      <div className="flex items-center gap-2">
        <Switch
          checked={user.active}
          onCheckedChange={() => handleToggle(user)}
          disabled={isPending}
        />
        <span className="text-sm">{user.active ? "Active" : "Inactive"}</span>
      </div>
    </TableCell>
  );
};
